/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_VENDOR_SUCCESS,
  LOAD_VENDOR_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_VENDOR_RECORDS_META_DATA_SUCCESS,
  LOAD_VENDOR_RECORDS_META_DATA_ERROR,
  CREATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_SUCCESS,
  DELETE_VENDOR_SUCCESS,
  CREATE_VENDOR_ERROR,
  UPDATE_VENDOR_ERROR,
  DELETE_VENDOR_ERROR,
  LOAD_VENDOR_CATEGORY_SUCCESS,
  LOAD_VENDOR_CATEGORY_ERROR,
  CREATE_VENDOR_CATEGORY_SUCCESS,
  CREATE_VENDOR_CATEGORY_ERROR,
  LOAD_VENDOR_COLLECT_SUCCESS,
  LOAD_VENDOR_COLLECT_ERROR,
  LOAD_VENDOR_PAY_SUCCESS,
  LOAD_VENDOR_PAY_ERROR,
  LOAD_VENDOR_TRANSACTION_SUCCESS,
  LOAD_VENDOR_TRANSACTION_ERROR,
} from "./constants";

const initialState = {
  vendor_list: [],
  vendor_collect_list: [],
  category_list: [],
  vendor_pay_list: [],
  vendor_transaction_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    vendor_list,
    category_list,
    vendor_collect_list,
    vendor_transaction_list,
    vendor_pay_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_VENDOR_SUCCESS:
        draft.vendor_list = vendor_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_VENDOR_COLLECT_SUCCESS:
        draft.vendor_collect_list = vendor_collect_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_VENDOR_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_VENDOR_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_VENDOR_PAY_SUCCESS:
        draft.vendor_pay_list = vendor_pay_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_VENDOR_TRANSACTION_SUCCESS:
        draft.vendor_transaction_list = vendor_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_VENDOR_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_VENDOR_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_VENDOR_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_VENDOR_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_VENDOR_ERROR:
      case LOAD_VENDOR_COLLECT_ERROR:
      case LOAD_VENDOR_PAY_ERROR:
      case LOAD_VENDOR_TRANSACTION_ERROR:
      case CREATE_VENDOR_ERROR:
      case UPDATE_VENDOR_ERROR:
      case DELETE_VENDOR_ERROR:
      case LOAD_VENDOR_CATEGORY_ERROR:
      case CREATE_VENDOR_CATEGORY_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_VENDOR_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
